import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';

const NotFoundWrapper = styled(Box)(({ theme }) => ({
  minHeight: '80vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3),
  textAlign: 'center',
}));

const ErrorCode = styled(Typography)(({ theme }) => ({
  fontSize: '120px',
  fontWeight: 700,
  background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  marginBottom: theme.spacing(2),
  lineHeight: 1,
}));

const NotFound = () => {
  return (
    <NotFoundWrapper>
      <Container maxWidth="sm">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <ErrorCode variant="h1">404</ErrorCode>
          
          <Typography 
            variant="h4" 
            sx={{ 
              mb: 3,
              fontWeight: 600,
              color: 'text.primary',
            }}
          >
            Page Not Found
          </Typography>
          
          <Typography 
            variant="body1" 
            color="text.secondary" 
            sx={{ mb: 5 }}
          >
            The page you're looking for doesn't exist or has been moved.
            Please check the URL or navigate back to the homepage.
          </Typography>
          
          <Button 
            component={Link}
            to="/"
            variant="contained"
            size="large"
            sx={{ px: 4, py: 1.5 }}
          >
            Back to Home
          </Button>
        </motion.div>
      </Container>
    </NotFoundWrapper>
  );
};

export default NotFound; 